$.fn.toggleForm = function(form) {
  let self = this;

  $(window).on('resize load orientationchange', function() {
    form.css('--max-height', form.find('.height-ruler').outerHeight() + parseInt(form.find('.height-ruler').css('margin-bottom')) + 'px');
  })

  self.on("click", function() {
    form.css('--max-height', form.find('.height-ruler').outerHeight() + parseInt(form.find('.height-ruler').css('margin-bottom')) + 'px');
    form.toggleClass('--open');
  });

  return function() {
    return self
  }()
}
